module.exports = __webpack_public_path__ + "img/mamtak_yes.856a8c50.png";